import { use } from 'react';
import ActivityBookingContext from '..';
const useActivityBookingAvailableLanguages = () => {
    const { setFetchLanguages, loadingAvailableLanguages, availableLanguagesQueryError, availableLanguages } = use(ActivityBookingContext);
    return {
        setFetchLanguages,
        loadingAvailableLanguages,
        availableLanguagesQueryError,
        availableLanguages
    };
};
export default useActivityBookingAvailableLanguages;
